import { VALIDATION_ERROR } from '../constants/strings';
import { SOMETHING_WENT_WRONG } from '../features/driverDetails/messages';

export const getErrorMessage = (error) =>
  error
    ? error.message || error.error?.message || SOMETHING_WENT_WRONG
    : SOMETHING_WENT_WRONG;

export const getStatusCode = (error) =>
  error?.statusCode || error.error?.statusCode || null;

export const isValidationError = (error) => {
  const statusCode = getStatusCode(error);
  return (
    statusCode === 400 && getErrorMessage(error).includes(VALIDATION_ERROR)
  );
};

export const containsOutstandingParcelRequests = (error) => {
  const errorMessage = getErrorMessage(error);
  return errorMessage.includes('outstanding parcel requests');
};

export const parseJSONfromError = (error, jsonMatchRegex) => {
  const parseRegex = jsonMatchRegex || /\[\{.*\}\]/;
  const jsonMatch = error.match(parseRegex);
  if (!jsonMatch) {
    return null;
  }
  const jsonData = JSON.parse(jsonMatch[0]);

  return jsonData;
};
